import { cloneDeep, get, has, omit } from 'lodash';
export default class Errors {
    errors = {};
    add(attribute, message) {
        if (!this.has(attribute)) {
            this.errors[attribute] = [];
        }
        if (this.errors[attribute].indexOf(message) === -1) {
            this.errors[attribute].push(message);
        }
    }
    missed(field) {
        return !this.has(field);
    }
    get(field) {
        return get(this.errors, field, []);
    }
    first(attribute) {
        if (this.has(attribute)) {
            return this.get(attribute)[0];
        }
        return undefined;
    }
    all() {
        return this.errors;
    }
    has(field) {
        return has(this.errors, field);
    }
    fill(errors) {
        this.errors = errors;
    }
    clear(attribute) {
        if (!attribute)
            return this.flush();
        const errors = omit(cloneDeep(this.errors), attribute);
        this.fill(errors);
    }
    flush() {
        this.fill({});
    }
}
